export const nxVersion = require('../../package.json').version;
// Also update @nx/remix/utils/versions when changing vite version
export const viteVersion = '^6.0.0';
export const viteV5Version = '^5.0.0';
export const vitestVersion = '^3.0.0';
export const vitestV1Version = '^1.3.1';
export const vitePluginReactVersion = '^4.2.0';
export const vitePluginReactSwcVersion = '^3.5.0';
export const jsdomVersion = '~22.1.0';
export const vitePluginDtsVersion = '~4.5.0';
export const ajvVersion = '^8.0.0';
export const happyDomVersion = '~9.20.3';
export const edgeRuntimeVmVersion = '~3.0.2';
export const jitiVersion = '2.4.2';

export const analogVitestAngular = '~1.17.1';

// Coverage providers
export const vitestCoverageV8Version = '^3.0.5';
export const vitestV1CoverageV8Version = '^1.0.4';
export const vitestCoverageIstanbulVersion = '^3.0.5';
export const vitestV1CoverageIstanbulVersion = '^1.0.4';
